import { AVAILABILITY_STATUS } from '../constants/availabilityStatus';
const { SOLD } = AVAILABILITY_STATUS;

/**
 * Function to count the number of units (apartments) on a specific reference tier.
 * @param {Array} apartments - Array of apartment objects.
 * @param {string|number} refTier - The reference tier to count units for.
 * @param {boolean} countSold - If true, counts sold apartments; if false, excludes them.
 * @return {number} - The count of units on the specified reference tier.
 */
export function countUnitsOnRefTier(
	apartments,
	refTier,
	countingForBuilding = false
) {
	let tierValueInt = parseInt(refTier);
	let count = 0;

	apartments.forEach((apartment) => {
		let hasApartment = false;

		if (countingForBuilding) {
			if (
				apartment.ref_tier === tierValueInt &&
				apartment.availability !== SOLD
			) {
				hasApartment = true;
			}
		} else if (
			apartment.tiers.map((tier) => tier.ref_tier).includes(tierValueInt)
		) {
			if (apartment.availability !== SOLD) {
				hasApartment = true;
			}
		}
		hasApartment && count++;
	});

	return count;
}

